<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button (click)="requestDebounced()" [disabled]="loading()"
          sb-button-primary [color]="'blue'"
          [loading]="loading()"
          type="button"
          [iconButton]="true"
          [icon]="'refresh'"
          sbTooltip="{{ 'lang.globals.refresh' | translate }}"
          container="body"
          placement="top">
  </button>
</ng-container>

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="900">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="selectedAsset" [innerHTML]="selectedAsset?.name | truncate : 30"></h4>
    <h4 *ngIf="!selectedAsset">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-shared-asset
    [sharedAsset]="selectedAsset"
    (convertToMediumClick)="convertToMedium($event)"
    (convertAllToMediaClick)="convertAllToMedia(selectedAsset)"
  ></sb-page-shared-asset>

</ng-template>


<!------------------------------

    Table wrapper

------------------------------->
@let isExpanded = checkExpansion();
@let ordering = orderOption();
<sb-table-wrapper-new
  [itemName]="'assets'"
  [itemsData]="assets()"
  [loading]="loading()"
  headline="{{'lang.headlines.motives' | translate}}"
  (paginationChange)="requestDebounced($event)"
  class="tw-w-full"
  [isFilterPanelOpen]="isExpanded"
>

  <!------------------------------

 Filter

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section title="{{'lang.globals.repositories' | translate}}"
                         icon="folderPhoto">
        <sb-filter-dto-list-select filterID="repositories" [endpoint]="api.mm_assets_AssetRepository_retrieveSharedRepositories.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <!--
      <sb-filter-section title="Tags"
                         icon="tags">
        <sb-filter-dto-list-select filterID="tags"
                                   [endpoint]="api.mm_assets_Asset_sharedAssetTags.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
-->

      <hr>
      <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col tw-mb-4">
        <div
          #filterPanelOrder
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit"
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
          <sb-icon class="" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                   icon="sort"></sb-icon>
          <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
          </div>
        </div>
        <div class="tw-flex tw-flex-grow tw-gap-2.5">

          @let fpOrderOption = filterPanelOrderOption();
          <sb-button-dropdown
            [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
            (outputChange)="setToOrderFilterPanel($event)"
            [openDirection]="'Up'"
            class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left"
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
          >
          </sb-button-dropdown>
          <sb-segment-control
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
            [selectedOption]="{value: fpOrderOption.direction}"
            [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
            (selectedOptionChange)="setOrderDirectionFilterPanel($event.value)"
          ></sb-segment-control>
        </div>
      </div>
    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th class="table--sortable" (click)="setToOrderAndRefresh(mm_assets_Asset_retrieveSharedAssets_order.ID)"
          [ngClass]="{'table--sorted': ordering?.value === mm_assets_Asset_retrieveSharedAssets_order.ID}">
        {{ 'lang.globals.id' | translate }}
        @if (ordering.value === mm_assets_Asset_retrieveSharedAssets_order.ID) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(mm_assets_Asset_retrieveSharedAssets_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value === mm_assets_Asset_retrieveSharedAssets_order.NAME}">
        {{ 'lang.globals.name' | translate }}
        @if (ordering.value === mm_assets_Asset_retrieveSharedAssets_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>
        {{ 'lang.globals.sharedBy' | translate }}
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(mm_assets_Asset_retrieveSharedAssets_order.SHARE_END)"
          [ngClass]="{'table--sorted': ordering?.value === mm_assets_Asset_retrieveSharedAssets_order.SHARE_END}">
        {{ 'lang.globals.sharedTill' | translate }}
        @if (ordering.value === mm_assets_Asset_retrieveSharedAssets_order.SHARE_END) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>
        Tags
      </th>
      <th>
        {{ 'lang.globals.repository' | translate }}
      </th>
      <th>
        {{ 'lang.globals.category' | translate }}
      </th>
      <th>
        {{ 'lang.globals.resolution' | translate }}
      </th>

      <th class="table--sortable" (click)="setToOrderAndRefresh(mm_assets_Asset_retrieveSharedAssets_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value === mm_assets_Asset_retrieveSharedAssets_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === mm_assets_Asset_retrieveSharedAssets_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(mm_assets_Asset_retrieveSharedAssets_order.CREATED_AT)"
          [ngClass]="{'table--sorted': ordering?.value === mm_assets_Asset_retrieveSharedAssets_order.CREATED_AT}">
        {{ 'lang.globals.createdAt' | translate }}
        @if (ordering.value === mm_assets_Asset_retrieveSharedAssets_order.CREATED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="tr last-col sticky-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-asset>

    <tr>
      <td>
        {{ asset?.id }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [still]="true" [hoverPreview]="true"
                                    [image]="asset?.preview?.thumbnailLink?asset?.preview?.thumbnailLink: asset?.preview?.link">
          <a firstLine class="cursor-pointer" (click)="editAsset(asset)" [innerHtml]="asset?.name|truncate:30"></a>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        {{ asset?.repository?.sharedBy?.name }}
      </td>
      <td>
        @if (asset?.shareEnd || asset?.repository?.shareEnd) {
          {{ dateTransformation.earlierDate(asset?.shareEnd, asset?.repository?.shareEnd)?.toString() |date: 'dd.MM.yyyy HH:mm' }}
        } @else {
          {{ "lang.globals.indefinitelyShared" | translate }}
        }
      </td>
      <td>
        <div *ngIf="asset.tags?.length < 4">
          <div *ngFor="let tag of asset?.tags">
            {{ tag }}
          </div>
        </div>
        <div *ngIf="asset.tags?.length > 4">
          <div class="d-flex">
      <span [ngbPopover]="popContent" autoClose="outside"
            class="tag grey-bg white cursor-pointer" container="body" popoverClass="tag-container">
    <sb-icon class="mr-1" icon="tags"></sb-icon>
        {{ asset.tags ? asset.tags.length : null }}
  </span>
          </div>
          <ng-template #popContent>
            <div class="d-flex">
      <span *ngFor="let tag of asset.tags"
            class="tag mr-1 cursor-pointer tag-input">
        <span [innerHTML]="tag | truncate: 5"></span>
    </span>
            </div>
          </ng-template>
        </div>
      </td>
      <td>
        {{ asset?.repository?.name }}
      </td>
      <td>
        {{ asset?.category?.name }}
      </td>
      <td>
        <div
          [ngbTooltip]="filesResolution" container="body" placement="left"
          class="tw-flex tw-w-fit tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-2 tw-px-4">
          {{ asset?.assetFiles?.length }}
        </div>
        <ng-template #filesResolution>
          <div *ngFor="let assetFile of asset?.assetFiles">
            {{ assetFile?.resolution?.width }}x{{ assetFile?.resolution?.height }}
          </div>
        </ng-template>
      </td>

      <td>
        <sb-comp-display-modified [data]="asset" [hideTooltip]="true"></sb-comp-display-modified>
      </td>
      <td>
        <sb-comp-display-created [data]="asset"></sb-comp-display-created>
      </td>
      <td class=" sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="asset?.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(asset, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->
  <!--
    <ng-template #card let-asset>
      <div>
        <sb-card>
          <div card-img classes="position-relative">

            <sb-preview-tooltip [interval]="5000" [hoverPreview]="false" [showFullOnClick]="true"
                                [customWidth]="100+'%'" [customHeight]="300+'px'"
                                [previews]="campaign?.preview"></sb-preview-tooltip>
            <div style="position: absolute;top: 15px;right: 15px">
              <button class="btn btn-danger" (click)="deleteAsset(asset)">
                <sb-icon icon="trash"></sb-icon>
              </button>
            </div>

          </div>
          <div card-footer>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                todo tags
              </div>
              <div class="d-flex">
                <sb-icon class="mr-1" icon="category"></sb-icon>
                {{asset?.category ? asset?.category?.name : '-'}}
              </div>
              <div class="d-flex ">
                <sb-icon class="mr-1" icon="resolution"></sb-icon>
                {{asset?.assetFiles ? asset?.assetFiles?.length : '-'}}
              </div>
            </div>
          </div>
        </sb-card>
        <h3>
          {{asset.name}}
        </h3>
      </div>
    </ng-template>
  -->
</sb-table-wrapper-new>
